
// controllers
import { UserController } from 'controllers';

export const isCustomerAtRisk = async ({ customerId, boxes }) => {

    const lastBoxes = boxes.slice(0, 2);
    let itemsCount = 0;
    let dislikedItemsCount = 0;
    for (const lbox of lastBoxes) {
        lbox.items = await UserController.getUserBoxItems(customerId, lbox.id);

        const itemsWithFeedback = lbox.items.filter(x => (x.feedback !== ''));
        itemsCount += itemsWithFeedback.length;

        const disliked = lbox.items.filter(x => x.feedback === "Didn't like it");
        dislikedItemsCount += disliked.length;
    }
    // is 50% or more bad `feedback`: "Didn't like it" ? FLAG : nothing (items)
    return dislikedItemsCount / itemsCount >= 0.5;
}
export const isCustomerWinBack = async (customer) => {
    if (customer?.win_back?.active) {
        const today = new Date();
        const fourMonthsAgo = today.setMonth(today.getMonth() - 4);
        const date = customer?.win_back.from;
        const stillActive = date >= fourMonthsAgo;
        if (!stillActive) {
            const payload = { win_back: { active: false } };
            await UserController.updateUserFields({ customerId: customer.id, payload });
        }
        return stillActive;
    }
    return false;
}
